import Table from 'components/commons/table'
import { TABLE_SETTING_POINT_COLLECTION } from 'configs/loyalty-program/configTableSettingPointCollection'
import { FormSettingPointCollection } from 'components/loyalty-program/setting-point-collection/FormSettingPointCollection'

export const SettingPointCollection = ({
    dataList,
    isLoading,
    onEditRow,
    onChangeForm,
    showModalEdit,
    onHideForm,
    pointCollectionDetail,
    errorForm,
    onSubmit,
    isUpdating,
}) => {
    return (
        <div className={'px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_SETTING_POINT_COLLECTION.name}
                columns={TABLE_SETTING_POINT_COLLECTION.column}
                data={dataList}
                totalResult={dataList?.length}
                onClickItem={onEditRow}
                loading={isLoading}
            />
            {showModalEdit && (
                <FormSettingPointCollection
                    show={showModalEdit}
                    onHideForm={onHideForm}
                    dataPointCollection={pointCollectionDetail}
                    isLoading={isUpdating}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
